import React from "react";
import { BrowserRouter, Routes, Route, Navigate, HashRouter } from "react-router-dom";
import Home from "../../../screens/home/Index";
import Login from "../../../screens/login/Index";
import NotFound from "../../../screens/notfound/Indesx";
import Contract from "../../../screens/contract/Index";
import Assign from "../../../screens/assign/Index";
import Bidding from "../../../screens/bidding/Index";
import Trips from "../../../screens/trips/Index";
import Participated from "../../../screens/bidding/ongoing/participated/Index";
import NotParticipated from "../../../screens/bidding/ongoing/not_participated/Index";

import 'bootstrap/dist/css/bootstrap.min.css';
import Upcoming from "../../../screens/bidding/upcoming/Index";
import Closed from "../../../screens/bidding/closed/Index";
import Archieve from "../../../screens/bidding/archieve/Index";
import Ongoing from "../../../screens/bidding/ongoing/Index";
import { NoPageFound } from "../../../components/NoPageFound/Index";
import AccountStatement from "../../../screens/account-statement/Index";
import { useAppSelector, useAppDispatch } from "../../../store/hooks";
import { addUser } from "../../../store/slices/user";
import Cookies from "js-cookie";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    const user = useAppSelector((state: any) => state.user);
    if (user?.userID === 0 && user?.transporterID === 0) {
        return <Navigate to="/" replace />;
    }
    return <>{children}</>;
};

const AppContainer = (props: any) => {
    const dispatch = useAppDispatch();
    const [rehydrated, setRehydrated] = React.useState(false);

    React.useEffect(() => {
        const userStr = Cookies.get('user');
        if (userStr) {
            try {
                const user = JSON.parse(userStr);
                if (user?.userID != null && user?.userID !== 0) {
                    dispatch(addUser(user));}
            } catch (e) {
                // ignore parse error
            }
        }
        setRehydrated(true);
    }, [dispatch]);

    if (!rehydrated) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                Loading...
            </div>
        );
    }

    return (
        <HashRouter basename="/">
            <Routes>
                <Route index path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />

                {/* home */}
                <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />

                {/* bidding routes */}
                <Route path="/bidding" element={<ProtectedRoute><Bidding /></ProtectedRoute>} />
                <Route path="/bidding/upcoming" element={<ProtectedRoute><Upcoming /></ProtectedRoute>} />

                <Route path="/bidding/ongoing" element={<ProtectedRoute><Ongoing /></ProtectedRoute>} />
                <Route path="/bidding/ongoing/notParticipated" element={<ProtectedRoute><NotParticipated /></ProtectedRoute>} />
                <Route path="/bidding/ongoing/participated" element={<ProtectedRoute><Participated /></ProtectedRoute>} />

                <Route path="/bidding/closed" element={<ProtectedRoute><Closed /></ProtectedRoute>} />
                <Route path="/bidding/archieve" element={<ProtectedRoute><Archieve /></ProtectedRoute>} />

                {/* contract */}
                <Route path="/contracts" element={<ProtectedRoute><Contract /></ProtectedRoute>} />

                {/* assign */}
                <Route path="/assigns" element={<ProtectedRoute><Assign /></ProtectedRoute>} />

                {/* trips */}
                <Route path="/trips" element={<ProtectedRoute><Trips /></ProtectedRoute>} />
                <Route path="/account-statement" element={<ProtectedRoute><AccountStatement /></ProtectedRoute>} />

                {/* not found */}
                <Route path="*" element={<NoPageFound />} />
            </Routes>
        </HashRouter>
    )
}

export default AppContainer